import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import  AuthService  from "../api/authentication.js";
import 'react-image-crop/dist/ReactCrop.css'
import ReactCrop, { makeAspectCrop } from 'react-image-crop'
import {base64StringtoFile,
    downloadBase64File,
    extractImageFileExtensionFromBase64,
    image64toCanvasRef} from '../setting/ResuableUtils.js'
    import axios from 'axios';
    const imageMaxSize = 1000000000 // bytes
    const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif'
    const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => {return item.trim()})





const Auth = new AuthService();
class  Image  extends Component {


  constructor(props){
        super(props)
        this.imagePreviewCanvasRef = React.createRef()
      this.state ={
         inputOpenFileRef : React.createRef(), 
         image : "",
         loading: false,
         file: '',
         imagePreviewUrl: '' ,
         imageuploing : "",
         clearimage : false,
         about : " ",
         Previewshow : true,
         submitIftrue : false,
        
           src: null,
           imgSrcExt: null,
           crop: {
             x: 10,
             y: 10,
             width: 80,
             height: 80,
           },
            fullname: '',
            location: "",
            account_no : "",
            phone_one : "",
            phone_two :"",
            registar : "",
            disableLink:false,
            everFocusedfullname: false,
            everFocusedlocation: false,
            imageurl : "",
            inFocus: '',
            noerorrpage :  true,
            imageerror : false,
            imagemessage :  "",
            uploading:false
      }
 }  

    
 onImageLoaded = (image) => {
    this.setState({
      crop: makeAspectCrop({
        x: 0,
        y: 0,
        aspect: 16 / 9,
        width: 50,
      }, image.width / image.height),
    });
  }

showOpenFileDlg = (event) => {
    this.state.inputOpenFileRef.current.click()
}
onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const reader = new FileReader();
    var file = event.target.files[0];
    // console.log("render", reader)
    reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result,
        });
      }
   
    // console.log("thus",this.state.imagePreviewUrl);
    ///console.log("thus",)
    // console.log(file);
    this.setState({file}); /// if you want to upload latter
    if(file){
        reader.readAsDataURL(file)
    }
   
}

handleDownloadClick = (event) => {
    event.preventDefault()
    console.log("download")
        this.setState({
            uploading:true
        })
    
    //const {imgSrc}  = this.state
    if (this.state.imagePreviewUrl) {
        // console.log("this.state.imagePreviewUrl4",  this.state.imagePreviewUrl)
        const canvasRef = this.imagePreviewCanvasRef.current
        //const {imgSrcExt} =  this.state
        // console.log("canvas Ref--- ---->", canvasRef);
        const imageData64 = canvasRef.toDataURL('image/jpeg');

        
        // console.log("imageData64 =======",  imageData64);
        // console.log("canvasRef",   canvasRef)
        // console.log("this.imagePreviewCanvasRef.current",   this.imagePreviewCanvasRef.current)
         const filesetiomsion   =   extractImageFileExtensionFromBase64(this.state.imagePreviewUrl)    
        //  console.log("filesetiomsion",filesetiomsion)

        const myFilename = "previewFile." + filesetiomsion

        // file to be uploaded
        const myNewCroppedFile = base64StringtoFile(this.state.imagePreviewUrl, myFilename)
        // console.log("myNewCroppedFile----->",myNewCroppedFile)

        const formData = new FormData();
        formData.append('uri', myNewCroppedFile)
        // console.log("file upload.....",this.state.file)
        formData.append('featured_image', true);
        formData.append('payment_item_id', this.props.payment_id);
       
        // this.setState({
        //     imageuploing : base64StringtoFile(this.state.imagePreviewUrl, myFilename)
        // })
    

        const options = {
            method: 'POST',
            headers: { 
          'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
            url: 'https://uvune-events.herokuapp.com/upload-logo',
        };

        axios.post(options.url, formData, options.headers).then((response) => {
            // console.log("res====------------>", response)
            if(response){
                          this.setState({
                        imageerror : true,
                        imagemessage :  "Upload  successful",
                        uploading:false
                    })
                    this.timeout() 
            }
            
        }).catch( err => {
            // console.log("errr", err);
            this.setState({
                uploading:false,
                imageerror : true,
                imagemessage :  "Sorry image to large",
            })
     const   data = {
                imageerror : "false",
                imagemessage: this.state.imagemessage
            }
            this.props.imageE(data)
            this.timeout() 
        });
      
        // download file
        // downloadBase64File(imageData64, myFilename)
       //this.downloadBase64File(imageData64, myFilename)
  
    }
}   

downloadBase64File = (base64Data, filename) => {
  
// console.log("response", base64Data, filename);
    var element = document.createElement('a')
     element.setAttribute('href', base64Data)
     element.setAttribute('download', filename)
    //  console.log("response", base64Data, filename);
    element.style.display = 'none'
    document.body.appendChild(element)
    // console.log("element", element ,"document",document);
    //  element.click()
    //  console.log("element", element.href);
     //console.log("this.state.imagePreviewUrl",this.state.imagePreviewUrl)
     const data = { 'uri': base64Data};
    //  console.log("base 24", data);
     const options = {
        method: 'POST',
        headers: { 
        'content-type': 'multipart/form-data',
        'access-control-allow-origin': '*',
        'Authorization': Auth.getToken(), 
        },
        data: data,
        url: 'https://uvuneapp.herokuapp.com/upload-logo',
     };

     axios(options).then((response) => {
        // console.log("response", response.data);
     });
   
  }

onCropChange = crop => {
    this.setState({ crop })
  }

  
  timeout() {
    setTimeout(function() {
        this.setState({
            imageerror : false
        })
      console.log(this.state.noticeshow);
    }.bind(this), 3000);
}

onCropComplete = (crop, pixelCrop) => {
    // console.log('onCropComplete judge', crop)
        this.setState({
            crop, 
            Previewshow: false
        
        })
    const canvasRef = this.imagePreviewCanvasRef.current;

    
        // console.log("canvas Ref", canvasRef);
        // console.log("pixel crop", pixelCrop);

        image64toCanvasRef(canvasRef,this.state.imagePreviewUrl,  pixelCrop);
        // console.log("------------", image64toCanvasRef(canvasRef,this.state.imagePreviewUrl,  pixelCrop));
}

onImageLoaded = image => {    
        this.verifyFile(image)
  
}


verifyFile = (files) => {
    // console.log("file", files)
    if (files && files.length > 0){
        const currentFile = files[0]
        const currentFileType = currentFile.type
        const currentFileSize = currentFile.size
        if(currentFileSize > imageMaxSize) {
            alert("This file is not allowed. " + currentFileSize + " bytes is too large")
            return false
        }
        if (!acceptedFileTypesArray.includes(currentFileType)){
            alert("This file is not allowed. Only images are allowed.")
            return false
        }
        return true
    }
}
  
   
    



  render() {
//  console.log("form or ticket DATA===---->", this.props.payment_id , this.props.payment)

    
    return (
                <div className="Home"> 
                   
                    {
                        this.state.imageerror ?   
                        <div className="build-image-error-M">
                             <strong>  {this.state.imagemessage} </strong>
                        </div>
                        :
                         <div></div>
                    }
                 <div className="columns">
                    <div className="column is-half">
                   <br/>
                   
                    { this.state.imagePreviewUrl ?  
                         <div className="build-image-magePreviewUrl">
                              {this.state.imagePreviewUrl && (
                                   <ReactCrop
                                    src={this.state.imagePreviewUrl}
                                    crop={this.state.crop}
                                    onImageLoaded={this.onImageLoaded}
                                    onComplete={this.onCropComplete}
                                    onChange={this.onCropChange}
                                />
                                )}
            
                              <div>
                                <br/>
                              <button className="button is-small is-success" onClick={()=>{this.upload.click()}}> <i className="fas fa-images icon-link"> </i> Change</button>
                              </div>    
                              
                        </div>   
                           
                            
                            :
                            <div>

                               {
                                    this.props.payment.featured_image_url?
                                    <div>
                                            {
                                                this.props.payment.featured_image_url === "" ? ( 
                                            
                                                <a className="image-hover" onClick={()=>{this.upload.click()}}>  <i className="far fa-image moresetting-logo"></i></a>    
                                                )
                                                :
                                                (
                                            <a className="image-hover" onClick={()=>{this.upload.click()}}> 
                                                    <div className="image-tag-settig-more-image_url">
                                                        <img src={   this.props.payment. featured_image_url} /> 
                                                    </div>
                                                
                                            </a>
                                                )
                                            }
                                    </div>   
                                    :
                                    <div className="image-tag-settig-more">
                                        <a className="image-hover" onClick={()=>{this.upload.click()}}> <i className="far fa-image moresetting-logo"></i> </a>    
                                    </div>          
                                }
                            </div>
                            // <div className=" build-image-image-logo-body">
                                
                            //     <a className=" is-small is-success" onClick={()=>{this.upload.click()}}>  
                            //     <i class="fas fa-images build-image-image-logo"></i>
                            //     </a>
                            
                            //     {/* <button className="button is-small is-success" onClick={()=>{this.upload.click()}}> Change</button> */}
                            // </div>
                    }
                     <input id="myInput"
                            type="file"
                            ref={(ref) => this.upload = ref}
                            style={{display: 'none'}}
                            onChange={this.onChangeFile.bind(this)}
                          />
                      <input ref={this.inputOpenFileRef} type="file" style={{display:"none"}}/>
                     </div>
                    

                        <div className="column">
             <br/>
                            {this.state.Previewshow ?
                                    <div className="thumbnail-hover"> 
                                        {/* <h2> note that every information you give to us we be confirmation , befor uptading  </h2> */}
                                    </div>
                              :
                                <div className="thumbnail-body">
                                    <canvas ref={this.imagePreviewCanvasRef} className="stop"></canvas>
                                    <div className="upload-butom-moreset">
                                    <br/>
                                        { !this.state.uploading ? 
                                          <button className="button is-small is-success " onClick={this.handleDownloadClick}><i className="fas fa-upload"> </i>Upload</button>  
                                          :
                                          <a className="button is-loading">Loading</a>
                                        }
                                        
                                    </div>
                                    </div>
                                
                             }    
                        </div>
                    </div>
                </div>

            )
        }
    }    
  export default  Image  ;      






// WEBPACK FOOTER //
// ./src/component/build/image.js